import { createTheme } from '@mantine/core';

export const theme = createTheme({
  primaryColor: 'blue',
  radius: {
    md: '8px'
  },
  fontFamily: 'Inter, sans-serif',
  headings: {
    fontFamily: 'Inter, sans-serif',
    sizes: {
      h1: { fontSize: '2rem' },
      h2: { fontSize: '1.5rem' },
      h3: { fontSize: '1.25rem' },
    },
  },
  components: {
    Button: {
      defaultProps: {
        radius: 'md',
      }
    }
  },
  colors: {
    brand: [
      '#E3F2FD',
      '#BBDEFB',
      '#90CAF9',
      '#64B5F6',
      '#42A5F5',
      '#2196F3',
      '#1E88E5',
      '#1976D2',
      '#1565C0',
      '#0D47A1'
    ]
  }
});
